import React from "react";
// import "./HomePart.css";
import "./HomePart.css"
// import resume from "../../../images/resume.pdf";
import { Link } from "react-router-dom";
import Typical from "react-typical";
import Particles from "react-tsparticles";
const HomePart = () => {
  

  const particlesInit = (main) => {
    console.log(main);
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };
  //test
  return (
    <div>
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          fpsLimit: 60,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              bubble: {
                distance: 400,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            links: {
              color: "#ffffff",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1,
            },
            collisions: {
              enable: true,
            },
            move: {
              direction: "none",
              enable: true,
              outMode: "bounce",
              random: false,
              speed: 1,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                value_area: 800,
              },
              value: 20,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              random: true,
              value: 5,
            },
          },
          detectRetina: true,
        }}
      />
      <div className="row welcome">
        <div className=" col-12  ">
          <h5 className="welcome-text">Hello! i am</h5>
          <h1 className="my-name-welcome">Iasir Arafat Riaz</h1>
          <h3>
            <span style={{ color: "white" }}> I Am A </span>
            <span className="welcome-text">
              {" "}
              <Typical
                steps={[
                  "Self Taught Programmer",
                  1200,
                  "Web Developer",
                  1200,
                  "Team Player",
                  1200,
                  "Entrepreneur",
                  1200,
                  "Motivator",
                  1200,
                ]}
                loop={Infinity}
                wrapper="h1."
              />
            </span>{" "}
          </h3>
          <div className="welcome-resume">
            <a className="resume" target="_blank" href="https://drive.google.com/file/d/1JRfGcuRwHTVjKHgxeySU0R8-V42ljhM_/view?usp=sharing">
              <b> View Resume</b>
            </a>
            {/* <a className="resume" download="Resume of Riaz" href={resume}>Download Resume</a> */}
            <Link className="aboutMe-button" to="/About">
              <b>About Me</b>
            </Link>
          </div>
          <div>
            <h4>
              <span className="followMe">Follow Me</span>
            </h4>
            <h3 className="followMe-icon">
              <a
                target="_blank"
                href="https://www.linkedin.com/in/iasir-arafat-riaz-a5a4811b8/"
              >
                <i class="fab fa-linkedin"></i>{" "}
              </a>
              <a target="_blank" href="https://github.com/Iasir-Arafat-riaz">
                <i class="fab fa-github"></i>{" "}
              </a>
              <a target="_blank" href=" https://twitter.com/Arafat_Riaz_CSE">
                <i class="fab fa-twitter"></i>{" "}
              </a>
              <a
                target="_blank"
                href="https://www.facebook.com/profile.php?id=100059987543734"
              >
                <i class="fab fa-facebook"></i>{" "}
              </a>
            </h3>
          </div>
        </div>
        {/* <div className="col-md-3 col-12">
          {" "}
          <h2>yee</h2>
        </div> */}
      </div>
    </div>
  );
};

export default HomePart;
